<div class="sales-opp-edit-container" *ngIf="salesOpportunity">
  <div
    class="mb-55 mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-between mct-items-center">
    <div class="mct-flex mct-row" *ngIf="profile?.ProfileId">
      <wl-profile-type-icon [isMember]="profile.Member" [isOrg]="profile.OrgInd"
        [styleOverrides]="{ 'max-height': '34px', 'max-width': '34px' }" [profileId]="profile.ProfileId"
        [memberTypeIconColor]="profile.MemberTypeIconColor"></wl-profile-type-icon>
      <h4>
        {{ profile.ReportName }} <span class="light-text">({{ profile.ProfileId }})</span>
      </h4>
    </div>
    <div class="flex row-collapse items-center w-50">
      <span class="mr-10 w-55 t-ar">{{ 'sales-opportunities.edit.working-with' | translate | ucfirst }}</span>
      <p-select placeholder="{{ 'sales-opportunities.edit.select-label' | translate }}"
        [(ngModel)]="salesOpportunity.WorkingWithProfileID" [options]="workingWithProfileItems"
        [style]="{ width: '50%', height: '36px' }" showClear (onChange)="workingWithChange($event)"></p-select>
    </div>
  </div>

  <div class="mb-27 mct-flex mct-row mct-flex-lt-lg mct-col-lt-lg mct-gap-27">
    <div class="mct-basis-50">
      <label class="light-text">{{ 'sales-opportunities.edit.revenue-item' | translate | ucfirst }}*</label>
      <p-select placeholder="{{ 'sales-opportunities.edit.select-label' | translate }}" appendTo="body"
        [(ngModel)]="salesOpportunity.ItemNum" [options]="revenueItems" [style]="{ width: '100%', height: '36px' }"
        showClear></p-select>
    </div>
    <div class="mct-basis-25">
      <label class="light-text">{{ 'sales-opportunities.edit.estimated-amount' | translate | ucfirst }}</label>
      <div class="input-group">
        <div class="input-group-addon">$</div>
        <input type="number" class="t-ar w-100" [(ngModel)]="salesOpportunity.EstimatedAmount" />
      </div>
    </div>
    <div class="mct-basis-19">
      <label class="light-text">{{ 'sales-opportunities.edit.estimated-close' | translate | ucfirst }}</label>
      <wl-date-selector [(ngModel)]="salesOpportunity.EsitmatedClose" appendTo="body"></wl-date-selector>
    </div>
  </div>

  <div class="mb-27 mct-flex mct-row mct-flex-lt-lg mct-col-lt-lg mct-gap-27">
    <div class="mct-basis-50">
      <label class="light-text">{{ 'sales-opportunities.edit.probability' | translate | ucfirst }}</label>
      <p-select placeholder="{{ 'sales-opportunities.edit.select-label' | translate }}" appendTo="body"
        [(ngModel)]="salesOpportunity.Probability" [options]="probabilityItems"
        [style]="{ width: '100%', height: '36px' }" showClear></p-select>
    </div>
    <div class="mct-basis-25">
      <label class="light-text">{{ 'sales-opportunities.edit.assigned-to' | translate | ucfirst }}*</label>
      <p-select placeholder="{{ 'sales-opportunities.edit.select-label' | translate }}" appendTo="body"
        [(ngModel)]="salesOpportunity.AssignedTo" [options]="assignedToUserItems"
        [style]="{ width: '100%', height: '36px' }" showClear></p-select>
    </div>
    <div class="mct-basis-19">
      <label class="light-text mct-flex mct-row mct-justify-start mct-items-center">
        <p-checkbox class="mr-5" binary="true" [(ngModel)]="salesOpportunity.Started"></p-checkbox>
        {{ 'sales-opportunities.edit.started-on' | translate | ucfirst }}
      </label>
      <wl-date-selector [(ngModel)]="salesOpportunity.DateStarted" appendTo="body"></wl-date-selector>
    </div>
  </div>

  <div class="mb-27 mct-flex mct-row mct-flex-lt-lg mct-col-lt-lg mct-gap-27">
    <div class="mct-basis-50">
      <label class="light-text">{{ 'sales-opportunities.edit.source' | translate | ucfirst }}</label>
      <p-select placeholder="{{ 'sales-opportunities.edit.select-label' | translate }}" appendTo="body"
        [(ngModel)]="salesOpportunity.Source" [options]="sourceItems" [style]="{ width: '100%', height: '36px' }"
        showClear></p-select>
    </div>
  </div>

  <div class="mb-27 mct-flex mct-row mct-flex-lt-lg mct-col-lt-lg mct-gap-27">
    <div class="mct-basis-50">
      <label class="light-text">{{ 'sales-opportunities.edit.closed-lost' | translate }}</label>
      <p-select placeholder="{{ 'sales-opportunities.edit.currently-open' | translate }}" appendTo="body"
        dataKey="actionId" optionLabel="actionLabel" [(ngModel)]="selectedClosedLostItem" [options]="closedLostItems"
        [style]="{ width: '100%', height: '36px' }" showClear (onChange)="closedLostChange($event.value)"></p-select>
    </div>
    <div class="mct-basis-25" [hidden]="!salesOpportunity.Closed">
      <label class="light-text">{{ 'sales-opportunities.edit.closed-actual-amount' | translate | ucfirst }}</label>
      <div class="input-group">
        <div class="input-group-addon">$</div>
        <input type="number" class="t-ar w-100" [(ngModel)]="salesOpportunity.ActualAmount" />
      </div>
    </div>
    <div class="mct-basis-19" [hidden]="!salesOpportunity.Closed">
      <label class="light-text">{{ 'sales-opportunities.edit.closed-date' | translate | ucfirst }}</label>
      <wl-date-selector [(ngModel)]="salesOpportunity.ClosedDate" appendTo="body"></wl-date-selector>
    </div>
    <div class="mct-basis-25" [hidden]="!salesOpportunity.Lost">
      <label class="light-text">{{ 'sales-opportunities.edit.lost-reason' | translate | ucfirst }}</label>
      <p-select placeholder="{{ 'sales-opportunities.edit.select-label' | translate }}" appendTo="body"
        [(ngModel)]="salesOpportunity.LostReason" [options]="lostReasons" [style]="{ width: '100%', height: '36px' }"
        showClear></p-select>
    </div>
    <div class="mct-basis-19" [hidden]="!salesOpportunity.Lost">
      <label class="light-text">{{ 'sales-opportunities.edit.lost-date' | translate | ucfirst }}</label>
      <wl-date-selector [(ngModel)]="salesOpportunity.LostDate" appendTo="body"></wl-date-selector>"
    </div>
  </div>

  <div class="mct-basis-25 mct-flex mct-col">
    <label class="light-text">{{ 'sales-opportunities.edit.notes' | translate | titlecase }}</label>
    <textarea cols="120" pInputTextarea [(ngModel)]="salesOpportunity.Descr"></textarea>
  </div>
</div>
